export default "__VITE_ASSET__Ne3BSJ1r__"